import { useEffect, useRef, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useActions } from 'statux'
import Form from '../../../components/Form/Form'
import InputPassword from '../../../components/InputPassword/InputPassword'
import RichText from '../../../components/RichText/RichText'

import authProvider from '../../../utils/auth-provider'
import { getQueryParams } from '../../../utils/location'

export default function Login (props = {
    heading: null,
    richText: null,
    submitBtnText: null,
    rememberMeText: null,
    redirect: null
}) {
    const history = useHistory()

    const errorMsg = useRef()

    const [errorState, setErrorState] = useState({
        message: null
    })

    const setUser = useActions('user')

    const onSubmit = (e) => {
        const accessControlRedirect = getQueryParams(history.location.search)
            .redirect

        const data = Array.from(e.target.querySelectorAll('input'))
            .map(el => ({
                [`${el.name}`]: el.name === 'remember'
                    ? el.checked
                    : el.value
            }))
            .reduce((acc, curr) => Object.assign(acc, curr), {})

        authProvider.login(data)
            .then(() => {
                if (authProvider.getDefaultRole() === 'admin'
                        && !accessControlRedirect)
                    return window.location.assign('/admin')

                history
                    .replace(accessControlRedirect
                        || props.redirect
                        || '/')

                setUser(authProvider.getIdentity())
            })
            .catch(err =>
                setErrorState({ message: err.message }))
    }

    useEffect(() => {
        if (errorState.message
                && errorMsg.current)
            errorMsg.current.focus()
    }, [errorState.message])

    let { richText } = props

    const id = 'login'

    const passwordMinLength = 8

    const ref = getQueryParams(history.location.search).ref
        || getQueryParams(getQueryParams(history.location.search).redirect || '')
            .ref

    richText = ref
        ? (richText || '')
            .replace(/(href=["|'])(.+?)(["|'])/g, (match, p1, p2, p3) => {
                const href = `${p2.replace(/&$/, '')}${
                    Object.keys(getQueryParams(p2)).length
                        ? '&'
                        : '?'}ref=${encodeURIComponent(ref)}`

                return `${p1}${href}${p3}`
            })
        : richText

    return (
        <div className="login">
            <h1
                className="heading-2 margin-b"
            >
                {props.heading || 'Login'}
            </h1>
            <RichText
                html={richText}
            />
            <Form
                id={id}
                className="login-form margin-3-t"
                onSubmit={onSubmit}
                aria-describedby={errorState.message
                    && `${id}-error-msg`}
            >
                <div className="form-field-floating margin-3-b">
                    <input
                        id={`${id}-email`}
                        name="email"
                        type="email"
                        autoComplete="on"
                        autoCapitalize="none"
                        spellCheck="false"
                        pattern="[a-zA-Z0-9\._%\+\-]+@[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,}$"
                        placeholder=" "
                        autoFocus
                        required
                    />
                    <label
                        htmlFor={`${id}-email`}
                    >
                        Email address
                    </label>
                    <p
                        id={`${id}-email-invalid`}
                        role="alert"
                    >
                        A valid email address is required
                    </p>
                </div>
                <div className="form-field-floating margin-3-b">
                    <InputPassword
                        id={`${id}-password`}
                        name="password"
                        type="password"
                        autoComplete="current-password"
                        autoCapitalize="none"
                        spellCheck="false"
                        minLength={passwordMinLength}
                        placeholder=" "
                        required
                    />
                    <label
                        htmlFor={`${id}-password`}
                    >
                        Password
                    </label>
                    <p
                        id={`${id}-password-invalid`}
                        role="alert"
                    >
                        A password with at least {passwordMinLength} characters is required
                    </p>
                </div>
                <div className="row flex-justify-content-space-between flex-align-items-center margin-4-t">
                    <div className="col-auto col-12-sm-down display-inline-flex flex-direction-column">
                        <button
                            className="btn-lg flex-grow-sm-down pad-5-l-sm-up pad-5-r-sm-up"
                            type="submit"
                        >
                            {props.submitBtnText || 'Submit'}
                        </button>
                        <p
                            ref={errorMsg}
                            id={`${id}-error-msg`}
                            className="margin-2-t"
                            role="alert"
                            style={{
                                display: errorState.message !== null
                                    && 'block'
                            }}
                            tabIndex="-1"
                        >
                            {errorState.message}
                        </p>
                        <div className="display-flex margin-t">
                            <input
                                id={`${id}-remember-me`}
                                type="checkbox"
                                name="remember"
                                value="1"
                            />
                            <label
                                htmlFor={`${id}-remember-me`}
                            >
                                {props.rememberMeText || 'Remember me'}
                            </label>
                        </div>
                    </div>
                    <div className="col-auto col-12-sm-down pad-4-b-sm-up pad-3-t-sm-down">
                        <Link
                            className="body-3 text-decoration-underline"
                            to="/forgot-password"
                        >
                            Forgot password
                        </Link>
                    </div>
                </div>
            </Form>
        </div>
    )
}
